import { LogLevel } from 'configcat-common';
import * as configcat from 'configcat-js';

export interface UserInfo {
  identifier: string;
  email?: string;
}

export interface ServiceClient {
  getAllKeys(callback: (value: string[]) => void): void;
  getValue: <T>(key: string, defaultValue: T, callback: (value: T) => void, user?: UserInfo) => void;
  dispose: () => void;
}

let clientSingleton: ServiceClient;

/**
 * The returned client is implemented as a singleton.
 *
 * Do not create separate clients as it could easily
 * exhaust our service quotas!
 */
export const getClient = ({
  sdkKey,
  pollIntervalSeconds,
}: {
  sdkKey: string;
  pollIntervalSeconds: number;
}): ServiceClient => {
  if (!clientSingleton) {
    const logger = configcat.createConsoleLogger(LogLevel.Warn);
    clientSingleton = configcat.createClientWithAutoPoll(sdkKey, {
      pollIntervalSeconds,
      logger,
    });
  }
  return clientSingleton;
};
